// extracted by mini-css-extract-plugin
export default {"previousQ":"PriceDelta__previousQ","line1":"PriceDelta__line1","line2":"PriceDelta__line2","line3":"PriceDelta__line3"};